'use client'
import { cn, type ModalProps } from "@heroui/react"
import { useLayoutEffect, useState } from "react"

const LAYER_CLASSES = [
  "z-[100]",
  "z-[110]",
  "z-[120]",
  "z-[130]",
  "z-[140]",
  "z-[150]",
  "z-[160]",
  "z-[170]",
  "z-[180]",
  "z-[190]",
] as const

/** 高于所有 modal 层，避免 toast 被遮罩挡住 */
export const TOAST_LAYER_CLASS = "!z-[200]"

let seq = 0
let openCount = 0

const acquireModalLayer = () => {
  const index = Math.min(seq, LAYER_CLASSES.length - 1)
  seq += 1
  openCount += 1
  return LAYER_CLASSES[index]
}

const releaseModalLayer = () => {
  openCount = Math.max(0, openCount - 1)
  if (openCount === 0) seq = 0
}

export const useModalLayer = (isOpen = false) => {
  const [layerClass, setLayerClass] = useState<string>()

  useLayoutEffect(() => {
    if (!isOpen) return
    setLayerClass(acquireModalLayer())
    return () => {
      setLayerClass(undefined)
      releaseModalLayer()
    }
  }, [isOpen])

  return layerClass
    ? { wrapper: layerClass, backdrop: layerClass }
    : undefined
}

export const mergeModalLayerClassNames = (
  classNames: ModalProps["classNames"] | undefined,
  layer?: { wrapper?: string; backdrop?: string },
): ModalProps["classNames"] => ({
  ...classNames,
  wrapper: cn(classNames?.wrapper, layer?.wrapper),
  backdrop: cn(classNames?.backdrop, layer?.backdrop),
})
